import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useState, type JSX } from "react";
import Left from "@repo/icons/default/Left";
import { CpsRadioButtonGroup, CpsRadioButtonV2 } from "corpus";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { Button } from "@/components/ui/button/button";

type HolderType = "cpf" | "cnpj";

const ChooseHolderTypePage = (): JSX.Element => {
  const router = useRouter();
  const [selectedType, setSelectedType] = useState<HolderType>("cpf");

  const handleContinue = (): void => {
    if (selectedType === "cpf") {
      void router.navigate({
        to: "/settings/payments/create-recipient/confirm-document",
      });
    } else {
      void router.navigate({
        to: "/settings/payments/create-recipient/check-cnpj",
      });
    }
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Cadastrar conta" align="center" />
      </HeaderRoot>
      <Page>
        <div className="flex flex-col gap-6">
          <h1 className="text-xl font-semibold text-neutral-600">
            Qual é a titularidade da conta que deseja cadastrar?
          </h1>

          <CpsRadioButtonGroup
            defaultValue="cpf"
            onChange={(value) => setSelectedType(value as HolderType)}
          >
            <CpsRadioButtonV2 value="cpf" label="CPF (conta PF)" id="cpf-option" />
            <CpsRadioButtonV2 value="cnpj" label="CNPJ (conta PJ)" id="cnpj-option" />
          </CpsRadioButtonGroup>

          <Button fullWidth onClick={handleContinue}>
            Continuar
          </Button>
        </div>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/create-recipient/choose-holder-type",
)({
  component: ChooseHolderTypePage,
});
